<template>
	<div class="stage-view-wrapper">
		<div class="stage-view-header">
			<!-- @slot Used to display stage view header  -->
			<slot name="header" />
		</div>
		<div class="stage-view-body">
			<!-- @slot Used to display stage view content -->
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "StageViewWrapper"
});
</script>
<style lang="scss">
.stage-view-wrapper {
	display: flex;
	flex-direction: column;
	padding: 0px 8px 0px 8px;
	> .stage-view-header {
		font-size: 18px;
		font-weight: 700;
		color: var(--dashboard-font-dark);
		line-height: 27px;
		/* border-bottom: 1px solid var(--dashboard-border); */
		/* margin-bottom: 20px; */
		padding-bottom: 12px;
		padding-top: 20px;
	}
	> .stage-view-body {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
		grid-gap: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}
}
</style>
